import { render, staticRenderFns } from "./UserAccountPurchasesMobileMenu.vue?vue&type=template&id=40d90272&"
import script from "./UserAccountPurchasesMobileMenu.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchasesMobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports